module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "introduction",
      "role": "doc-introduction"
    }
  }, [_c('h1', {
    staticClass: "h1a"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 6",
      "epub:type": "pagebreak",
      "id": "page_6",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 7",
      "epub:type": "pagebreak",
      "id": "page_7",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 8",
      "epub:type": "pagebreak",
      "id": "page_8",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 9",
      "epub:type": "pagebreak",
      "id": "page_9",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Introduction")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Nothing sounds sweeter than the crack of that slim aluminum can, home to a 100-calorie bubbly beauty. Spring, summer, whatever the time of year, it’s hard seltzer season.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("At 4 to 6 percent alcohol content, it’s not a bad deal! But sometimes you have to take it up a notch…or several. I mean, that’s what we’re all here for if we’re being honest, right? Hard seltzer (also called spiked seltzer) is the perfect mixer to make a boozy drink that much boozier.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("What’s the right ratio? What actually tastes like a cocktail, doesn’t skimp, but also doesn’t immediately send you to blackout town? Well, my friend, that is where my help comes in. The recipes from here on out are dangerously delicious and designed to get the party going, whether it’s a Friday night pregame or your next big party—or if it’s just been a tough day (girl, you do you). Instead of that next round of probably (always) regrettable tequila shots, pick up this book and let’s get bubbly.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_vm._v("WHAT IS HARD SELTZER, ANYWAY?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You may have noticed in stores that hard seltzer is in the refrigerated display case with all the beer. But it’s not exactly beer, is it? The production process is very similar to beer, but seltzer "), _c('span', {
    attrs: {
      "aria-label": "page 10",
      "epub:type": "pagebreak",
      "id": "page_10",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("is made from fermented cane sugar instead of malted barley. Most seltzers are advertised as being made with “real fruit juice,” which is true (at least for the major brands)! That’s where the flavor comes from—not from artificial sweeteners. As a result, we get to enjoy drinks that are low in calories and low in sugar. As an added bonus, most seltzers are gluten-free as well!")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_vm._v("TYPES OF HARD SELTZER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As of this writing, there are a ton of different seltzer brands. Wherever you’re reading this from, you have no doubt encountered the major players, such as White Claw, Truly, and Spiked Seltzer; but there are also tons of local booze players trying to get into this game. My scientific research"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042197/xhtml/intro#footnote-001",
      "id": "footnote-001-backlink"
    }
  }, [_vm._v("1")])]), _vm._v(" has shown that for the most part the seltzer flavors listed here often overlap between brands. In this book I’ve tried to use an assortment of the readily available flavors, so you should be able to find them at most stores. If you’re having trouble, you can and should definitely trust your taste buds in terms of substitutions. Here’s my advice on improvising with the various seltzer flavors:")]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Citrus flavors.")]), _vm._v(" When it comes to the “classics,” citrus flavors—like lemon, orange, tangerine, clementine, grapefruit, and lime—are a must-have and are the easiest to swap out. Lime is by far the strongest of the citrus flavors; I personally feel it has a little more kick. When replacing, make sure to taste test.")]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 11",
      "epub:type": "pagebreak",
      "id": "page_11",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Berry flavors.")]), _vm._v(" Berry flavors include strawberry, raspberry, cranberry, and mixed berry; they are pretty strong, so I wouldn’t recommend mixing them with a dark liquor. They are great for upgrading your basic drinks without adding flavored syrup. For example, upgrading a classic lime daiquiri to raspberry would just require swapping out lime (or any other flavor) seltzer for raspberry seltzer!")])]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Black cherry.")]), _vm._v(" You’re either a black cherry person or you’re not. If you are, you’re in luck because the superstrong flavor profile will overpower most drinks. If you’re looking to mask a ton of liquor, even tequila, black cherry is your new BFF. I don’t include black cherry as a suggestion in many of these recipes because it is so overpowering. But if you really love it, feel free to swap it in.")]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("“Tropical” flavors.")]), _vm._v(" Choices like passionfruit, pineapple, mango, and strawberry kiwi really shine in the frozen/slushy drinks, but feel free to mix and match.")]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Seasonal flavors.")]), _vm._v(" As of this writing, many of the major brands have come out with “seasonal” flavors that may or may not be available depending on when you’re making these drinks. For example, in fall 2020, Bud Light debuted the Ugly Sweater variety pack, which included fall/winter-themed flavors like Apple Crisp and Ginger Snap. For the seasonal drinks, I’ve noted where you could give such seltzers a try. I’ve only suggested seasonal flavors for the holiday drinks and have offered substitutions if you don’t have them on hand.")]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Sparkling hard cider.")]), _vm._v(" Many cideries are also making hard seltzer, or “sparkling” cider. Those are more apple-flavored than many "), _c('span', {
    attrs: {
      "aria-label": "page 12",
      "epub:type": "pagebreak",
      "id": "page_12",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("of the traditional spiked seltzer flavors, but they work great in sangrias and tropical drinks. While sparkling cider is not technically a hard seltzer, I’m open to the substitution if you have it on hand!")])]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Hard lemonade.")]), _vm._v(" Some of our go-to brands, such as Truly, have lemonade flavors that are particularly nice in the frozen cocktails. But brands like Mike’s Hard Lemonade have been around forever and are essentially the same thing. You can absolutely use those as well!")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "snoind"
  }, [_vm._v("Trust your taste buds and use the flavors that you like. If you don’t like pineapple, swap it out for another flavor. If you’re not sure how to choose a substitution, just use a flavor you do like from the same variety pack. The other flavors that come in the box are often good choices.")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_vm._v("OTHER BOOZE TO HAVE ON HAND")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The recipes in this book range from classic martinis to jungle juice. If you want to make them all, you may need to start stocking your bar. Classic liquors are always good to have around, but make sure to check recipes for some of the more out-there punches, which use some less common liquors and liqueurs!")]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_100",
    attrs: {
      "alt": "Image",
      "src": "e9781646042197/images/f0012-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 13",
      "epub:type": "pagebreak",
      "id": "page_13",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("THE CLASSICS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While there are plenty more liquors out there that you can have on your bar cart, the necessary ones for this book are listed below. Believe it or not, it’s not just clear liquors on this list!")]), _vm._v(" "), _c('ul', {
    staticClass: "ilist"
  }, [_c('li', {
    staticClass: "bull"
  }, [_vm._v("Bourbon")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Brandy")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Cognac")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Cointreau or triple sec")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Gin")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Rum (dark and light)")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Rye")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Tequila (the blanco, or silver, variety)")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Vermouth (dry and sweet varieties)")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Vodka")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_vm._v("WINE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I hope that this is obvious, but don’t go using that bottle of wine you’ve been saving since your trip to Paris for the recipes in this book. Use wines that you like, but certainly don’t spend more than $20 on a bottle. Here are some suggested wines to have around:")]), _vm._v(" "), _c('ul', {
    staticClass: "ilist"
  }, [_c('li', {
    staticClass: "bull"
  }, [_vm._v("Prosecco or other sparkling white wine")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Red wine, ideally Spanish for sangria")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Rosé")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("White wine")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 14",
      "epub:type": "pagebreak",
      "id": "page_14",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("LESS COMMON LIQUEURS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You don’t need to go crazy here, but you may need some less common liqueurs to round out these drinks. It’s always smart to have a bottle (or two) of Aperol at the ready—every party loves a spritz!")]), _vm._v(" "), _c('ul', {
    staticClass: "ilist"
  }, [_c('li', {
    staticClass: "bull"
  }, [_vm._v("Aperol (a bitter, bright orange Italian apéritif)")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Blue curaçao (a bright blue liqueur from Curaçao that’s flavored with laraha, a native bitter orange)")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Campari (a bitter, dark red Italian apéritif)")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Coconut-flavored rum (such as Malibu)")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Peach schnapps")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_vm._v("MIXERS, GARNISHES, AND OTHER ACCOUTREMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s not just about the booze! You’ll need some nonalcoholic additions to make your cocktails complete. This list has everything, from your classic mixers (like orange juice and cranberry juice cocktail) to the unexpected (like soy sauce and vanilla ice cream).")]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_vm._v("MIXERS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There’s a lot of juice on this list of mixers. If you can find it (or squeeze it), fresh juice is always preferable.")]), _vm._v(" "), _c('ul', {
    staticClass: "ilist"
  }, [_c('li', {
    staticClass: "bull"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 15",
      "epub:type": "pagebreak",
      "id": "page_15",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Apple cider or juice")])]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Bitters (such as Angostura or Peychaud’s)")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Black tea")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Cola soft drink")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Cranberry juice cocktail")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Cream of coconut")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Fruit punch")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Ginger beer")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Grapefruit juice")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Grenadine")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Lemon juice")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Lemonade")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Lime juice")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Orange juice")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Peach or apricot puree/nectar")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Pineapple juice")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Simple syrup")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Soda water")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Tomato juice or Clamato")])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar2"
  }, [_c('p', {
    staticClass: "stitle"
  }, [_vm._v("Easy Simple Syrup")]), _vm._v(" "), _c('p', {
    staticClass: "snoind1"
  }, [_vm._v("There’s no reason to buy simple syrup—it’s supereasy to make it yourself. I like to have some available at all times. You never know when you want a cocktail ASAP! Make some now and keep it handy.")]), _vm._v(" "), _c('p', {
    staticClass: "snoind1"
  }, [_vm._v("The ratio is 1:1; you can scale this up or down as needed. Store the syrup in the fridge, and it should keep for about four weeks.")]), _vm._v(" "), _c('ul', {
    staticClass: "ingred-listbx"
  }, [_c('li', {
    staticClass: "itembx"
  }, [_vm._v("1 cup white sugar")]), _vm._v(" "), _c('li', {
    staticClass: "itembx"
  }, [_vm._v("1 cup water")])]), _vm._v(" "), _c('ol', {
    staticClass: "step-listbx"
  }, [_c('li', {
    staticClass: "stepbx"
  }, [_vm._v("1. Combine the sugar and water in a small saucepan over medium heat.")]), _vm._v(" "), _c('li', {
    staticClass: "stepbx"
  }, [_vm._v("2. Stir until the sugar is dissolved. Remove from the heat and let cool completely.")]), _vm._v(" "), _c('li', {
    staticClass: "stepbx"
  }, [_vm._v("3. Pour the syrup into an airtight glass container (I like to use a mason jar), and store it in the fridge.")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 16",
      "epub:type": "pagebreak",
      "id": "page_16",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("OTHER ITEMS USED IN THESE RECIPES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can keep these around for non-booze-related activities, too. Odds are you have most of them in your pantry or fridge already!")]), _vm._v(" "), _c('ul', {
    staticClass: "ilist"
  }, [_c('li', {
    staticClass: "bull"
  }, [_vm._v("Hot sauce")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Jell-O/gelatin")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Milk")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Soy sauce")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Vanilla extract")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Vanilla or raspberry ice cream")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Worcestershire sauce")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_vm._v("FRESH/FROZEN FRUITS AND VEGETABLES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Frozen fruit is great for frozen drinks because it cuts down on how much ice you need to have on hand. If you don’t like a particular fruit or are allergic, just swap it out for another you prefer instead.")]), _vm._v(" "), _c('ul', {
    staticClass: "ilist"
  }, [_c('li', {
    staticClass: "bull"
  }, [_vm._v("Cranberries, fresh")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Cucumber")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Grapefruit")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Green apple")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Lemon")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Lime")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Mango chunks, frozen")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Mixed berries, frozen and fresh")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Orange")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Seedless watermelon, fresh")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Strawberries, frozen and fresh")])]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_40",
    attrs: {
      "alt": "Image",
      "src": "e9781646042197/images/f0016-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 17",
      "epub:type": "pagebreak",
      "id": "page_17",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("GARNISHES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Are garnishes absolutely necessary? No. Are they classy AF? You bet. Adding a fresh rosemary sprig or cinnamon stick to your cocktail can be the perfect touch for your Instagram story.")]), _vm._v(" "), _c('ul', {
    staticClass: "ilist"
  }, [_c('li', {
    staticClass: "bull"
  }, [_vm._v("Celery")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Celery salt")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Chili powder")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Cinnamon")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Egg whites")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Maraschino cherries")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Mint, fresh")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Nutmeg, ground")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Olives")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Paprika")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Pepper")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Rosemary, fresh")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Sea salt")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Sugar")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Sugar cubes")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_vm._v("TOOLS YOU’LL NEED")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You don’t need to buy a fancy bartender’s kit for these recipes, but you will need a few crucial supplies. If you’re packing items for a bachelorette weekend or just want to make sure your kitchen is outfitted, here are the essentials:")]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Bar spoon.")]), _vm._v(" This is really just a long spoon for mixing cocktails that aren’t shaken. If you don’t have a bar spoon, you can substitute with the longest spoon in your kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Blender.")]), _vm._v(" Any stationary blender will work for frozen cocktails.")]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 18",
      "epub:type": "pagebreak",
      "id": "page_18",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Cocktail shaker.")]), _vm._v(" Also known as a “cobbler shaker,” the classic cocktail shaker consists of a cup, strainer, and lid, perfect for shaking, mixing, and pouring.")])]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Ice pop molds and wooden sticks.")]), _vm._v(" These are only used for the "), _c('span', {
    attrs: {
      "href": "#/e9781646042197/xhtml/ch02_rec07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clawsicles")]), _vm._v(". Not all ice pop molds require wooden sticks, so check what kind of molds you have.")]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Juicer.")]), _vm._v(" I highly recommend using fresh juice whenever you can. A small manual juicer is great to have; mine fits on top of a mason jar and doesn’t take up too much room in my drawers.")]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Large pitcher or punch bowl.")]), _vm._v(" Select a pitcher or punch bowl that can hold at least a gallon; you’ll want to make sure that you have enough to go around for the party drinks.")]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Measuring cups.")]), _vm._v(" When it comes to large-batch cocktails, you’ll put away the shot glass and start working with larger quantities, so you will need measuring cups in three sizes: ¼ cup, ½ cup, and 1 cup.")]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Paring knife and small cutting board.")]), _vm._v(" A small knife and cutting board will be nice to have for slicing lime wedges and other garnishes.")]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Plastic condiment cups.")]), _vm._v(" These are only used for the "), _c('span', {
    attrs: {
      "href": "#/e9781646042197/xhtml/ch04_rec03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sparkling Jell-O Shots")]), _vm._v(". Usually 2 ounces, these often come with plastic lids that are great for storing in the fridge.")]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Shot glass.")]), _vm._v(" A shot glass is a must-have. Most are 1 or 2 ounces; make sure you know what size you have so you don’t under- or over-pour. This is used for measuring, so if you’re buying a new "), _c('span', {
    attrs: {
      "aria-label": "page 19",
      "epub:type": "pagebreak",
      "id": "page_19",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("shot glass, I recommend getting one with fill lines that show the amounts on the side.")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_vm._v("SELTZER-FRIENDLY GLASSWARE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’ve offered suggestions for glassware where appropriate, but honestly, these are some pretty hefty cocktails. Unfortunately, all those cute coupes and dainty champagne glasses are out of the picture unless you’re serving from a pitcher. I’ve downsized this glassware list to the major oversized glassware (and some more creative variations) that can hold anywhere from 8 to 16 ounces of liquid. Feel free to pick and choose when you’re crafting these recipes!")]), _vm._v(" "), _c('p', {
    staticClass: "imagex"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "e9781646042197/images/f0019-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Oversized cocktail glasses.")]), _vm._v(" You probably know the cocktail glass as a martini glass. Most martini glasses that you buy at the store these days are technically “oversized”; make sure yours are properly huge (more than 10-ounce capacity).")]), _vm._v(" "), _c('p', {
    staticClass: "imagex"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "e9781646042197/images/f0019-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Double old-fashioned glasses.")]), _vm._v(" Also known as a rocks glass. Make sure you’ve got doubles—these cocktails are certainly not singles.")]), _vm._v(" "), _c('p', {
    staticClass: "imagex"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "e9781646042197/images/f0019-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Wine glasses.")]), _vm._v(" Don’t try to break out those tiny free glasses you got at a wine tasting; you are going to need the big mamas for these cocktails. I recommend using white-wine glasses over red because they’re designed to keep drinks cooler for longer.")]), _vm._v(" "), _c('p', {
    staticClass: "imagex"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "e9781646042197/images/f0020-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 20",
      "epub:type": "pagebreak",
      "id": "page_20",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Margarita glasses.")]), _vm._v(" These shallow-bowled, wide-rimmed glasses aren’t just for margs! Feel free to break these out for any of the frozen cocktails.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagex"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "e9781646042197/images/f0020-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Hurricane glasses.")]), _vm._v(" Nothing screams “hot summer days” like the curves of a hurricane glass.")]), _vm._v(" "), _c('p', {
    staticClass: "imagex"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "e9781646042197/images/f0020-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Copper mugs.")]), _vm._v(" This one is traditionally used to serve a Moscow mule, but it’s great for these cocktails if you want to keep things cool and classy.")]), _vm._v(" "), _c('p', {
    staticClass: "imagex"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "e9781646042197/images/f0020-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Pint glasses.")]), _vm._v(" Your classic beer glass is perfect for these cocktails. It’s got the capacity to handle ice, seltzer, and liquor.")]), _vm._v(" "), _c('p', {
    staticClass: "imagex"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "e9781646042197/images/f0020-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Highball glasses.")]), _vm._v(" Tall and skinny, these glasses work well for all types of cocktails and are sure to impress in a pinch. A Collins glass is similar and works well also; the only difference is that it’s slightly taller.")]), _vm._v(" "), _c('p', {
    staticClass: "imagex"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "e9781646042197/images/f0020-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Mason jars.")]), _vm._v(" Not a traditional cocktail glass by any means, but it’s a great (and cheap) way to keep it classy, serve a crowd, and still contain all that fizzy goodness.")]), _vm._v(" "), _c('p', {
    staticClass: "imagex"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "e9781646042197/images/f0020-07.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "runintxt"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Solo cups.")]), _vm._v(" I had to add it. Your trusty red plastic Solo cup absolutely does the trick here. It’s certainly less classy, but no one said that you couldn’t have a martini in a red cup.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 21",
      "epub:type": "pagebreak",
      "id": "page_21",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("A NOTE ON RECIPES AND ORGANIZATION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The recipes are organized into four different chapters based on the potential party you’re hosting or the day-drinking situation you’ve found yourself in. For example, Chapter One, “Boozy Brunch,” is full of your late-morning favorites, from mimosas to micheladas. If you’re looking for a specific drink, you can always flip to the index.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("With the exception of a few single-serving cocktails and the batch “party” cocktails, most of the recipes in this book use one 12-ounce can of hard seltzer and serve two. Feel free to scale up or down as needed.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042197/xhtml/intro#footnote-001-backlink",
      "id": "footnote-001"
    }
  }, [_vm._v("1")]), _vm._v(" Just kidding; do not mistake the author for someone who has any knowledge of science.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-332091c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781646042197/xhtml/intro.vue
// module id = 66
// module chunks = 0